import React from "react";
import moment from "moment";
import {TableWrapper} from "components/_defaultComponents/TableWrapper/TableWrapper";
import {paymentContractActivityStatuses} from "constants/constants";
import {Button, Popconfirm, Tag, Tooltip, message} from "antd";
import styled from "styled-components";
import {PoolPaymentContractDetail} from "./PoolPaymentContractDetail/PoolPaymentContractDetail";
import {Shortener} from "components/_defaultComponents/Shortener/Shortener";
import {useStore} from "hooks/useStore";
import {generatePaymentContractActivityStatus} from "utils/generatePaymentContractActivityStatus";

const PaymentContractStatus = styled.div`
    @media (max-width: 768px) {
        text-align: right !important;
    }
`;

export const PoolPaymentContractsTable = ({
    poolPaymentContracts = [],
    size = "large",
    refetch = async () => {},
    showTitle = true,
    ...props
}) => {
    const stores = useStore();

    const handleCancelContract = async ({contractId}) => {
        try {
            // Pool için cancel endpoint'i varsa burada kullanılabilir
            // await stores.poolStore.cancelPoolPaymentContract({contractId});
            message.info("Bu özellik henüz desteklenmiyor");
            await refetch();
        } catch (error) {
            message.error(error.message);
        }
    };

    const columns = [
        {
            title: "Detay",
            dataIndex: "_id",
            render: (_id, record) => (
                <PoolPaymentContractDetail poolPaymentContract={record} key={_id} />
            )
        },
        {title: "Sözleşme Id", dataIndex: "contractId"},
        {
            title: "Başlangıç Tarihi",
            dataIndex: "startDate",
            render: date => (date ? moment(date).format("DD.MM.YYYY") : "-")
        },
        {
            title: "Bitiş Tarihi",
            dataIndex: "endDate",
            render: date => (date ? moment(date).format("DD.MM.YYYY") : "-")
        },
        {
            title: "Durumu",
            dataIndex: "activityStatus",
            style: {height: "500px"},
            render: (activityStatus, record) => (
                <PaymentContractStatus>
                    <Tag
                        color={
                            paymentContractActivityStatuses?.find(
                                status => status?.value === activityStatus
                            )?.color
                        }
                    >
                        {paymentContractActivityStatuses?.find(
                            status => status?.value === activityStatus
                        )?.name || activityStatus}
                    </Tag>
                </PaymentContractStatus>
            )
        },
        {
            title: "Aksiyon",
            dataIndex: "activityStatus",
            render: (activityStatus, record) => (
                <>
                    {stores.meStore.checkRole("cancelSubCompanyFuturePaymentContracts") &&
                        activityStatus === "future" && (
                            <Popconfirm
                                title="Bu kontratı iptal etmek istediğinize emin misiniz?"
                                onConfirm={() => handleCancelContract({contractId: record._id})}
                                okText="Evet"
                                cancelText="Hayır"
                            >
                                <Button type="danger" size="small" danger>
                                    İptal Et
                                </Button>
                            </Popconfirm>
                        )}
                </>
            )
        }
    ];

    return (
        <>
            <TableWrapper
                rowKey="_id"
                dataSource={poolPaymentContracts.map(paymentContract => {
                    const activityStatus = generatePaymentContractActivityStatus(paymentContract);
                    return {
                        ...paymentContract,
                        activityStatus
                    };
                })}
                columns={columns.filter(column => !column.hidden) || []}
                size={size}
                pagination={false}
                renderTitle={() =>
                    showTitle && (
                        <h3 style={{fontWeight: 700, fontSize: 20}}>Havuz Ödeme Sözleşmeleri</h3>
                    )
                }
                {...props}
            />
        </>
    );
};
